(ns practitest.frontend.testset2.add-instance2
  (:require [practitest.frontend.common-entities.events :as common-events]
            [practitest.frontend.common-entities.index :refer [panel-config]]
            [practitest.frontend.common.dom :as dom]
            [practitest.frontend.common.i18n :refer [get-translation]]
            [practitest.frontend.common.re-frame :refer [partial-dispatch
                                                         partial-subscribe]]
            [practitest.frontend.components.grid.events :as grid.events]
            [practitest.frontend.components.grid.localstorage :as grid-storage]
            [practitest.frontend.components.grid.sessionstorage :as grid-session-storage]
            [practitest.frontend.components.grid.subs :as grid.subs]
            [practitest.frontend.components.icons :as icons]
            [practitest.frontend.components2.grid :as grid2]
            [practitest.frontend.components2.resize-panel :refer [panel-group
                                                                  panel-resize-handle
                                                                  panel-resizeable]]
            [practitest.frontend.folders :as folders]
            [practitest.frontend.forms3.entity-form.forms :as forms]
            [practitest.frontend.pt-ts-bridge :refer [FiltersPanel]]
            [practitest.frontend.subs :as subs]
            [practitest.frontend.testset2.events :as testset2]
            [practitest.frontend.testset2.subs :as testset.subs]
            [re-frame.core :as re-frame]
            [reagent.core :as reagent]))

(defonce test-fields-to-exclude '(:name
                                   :test_type
                                   :display_id
                                   :description))

(defn- transform-test-name-for-url
  "Transform test name into clickable URL format"
  [item]
  (update item :name (fn [name] {:url (:url item) :title name})))

(defn- tree-node-element
  [local-state-updating props level node]
  (let [{:keys [children id]} node
        has-children? (seq children)
        ;; TODO: Should be expanded when selected item is inside the tree
        expanded? (contains? (:expanded @local-state-updating) id)
        selected? (= id (:id (:current-item props)))
        on-item-selected (:on-item-selected props)]
    (concat [^{:key id}
             [:li.list-group-item
              {:style    {:margin-left (str level "em")}
               :class    (dom/classes-pairs
                           :list-group-item-info selected?)
               :on-click (fn [e]
                           (when on-item-selected
                             (on-item-selected node)))}

              (when has-children?
                ;; TODO: make this span bigger (to make clicking easier) / move on-click to list-item ?
                [:span.clickable
                 {:style    {:height "100%"}
                  :on-click (when has-children?
                              (fn [e]
                                (dom/prevent-default e)
                                (dom/stop-propagation e)
                                (if expanded?
                                  (swap! local-state-updating update :expanded disj id)
                                  (swap! local-state-updating update :expanded conj id))))}

                 (if expanded?
                   [icons/svg-chevron-down]
                   [icons/svg-chevron-right])])
              ;; TODO: use css for this
              " "
              [:a {:href "#"
                   :on-click (fn [e]
                               (dom/prevent-default e))}
               (:name node)]]]

            (when (contains? (:expanded @local-state-updating) id)
              (mapcat #(tree-node-element local-state-updating props (inc level) %)
                      children)))))

(defn filters-view [_]
  (fn [{:keys [module grid-state]}]
      (let [
            options @(re-frame/subscribe [::subs/options])
            on-filter-select (partial-dispatch [::common-events/set-current-filter
                                                :test
                                                :add-instances-state
                                                ::common-events/fetch-entity-list
                                                grid-state])
            on-folder-select (partial-dispatch [::common-events/set-current-folder
                                                :test
                                                :add-instances-state
                                                ::common-events/fetch-entity-list-by-folder
                                                grid-state])
            user-id (:id @(re-frame/subscribe [::subs/current-user]))
            project-id (:id @(re-frame/subscribe [::subs/current-project]))
            all-entity-fields (re-frame/subscribe [::subs/all-entity-fields])]
        (into [:div.filters-view-modal.overlay-parent
               [:> FiltersPanel {:scope {:module  module  :user-id (str user-id) :project-id (str project-id)}
                                 :isDataReady  (boolean @all-entity-fields)
                                 :notifyFilterChanged #(on-filter-select (js->clj % :keywordize-keys true))
                                 :notifyFolderChanged #(on-folder-select (js->clj % :keywordize-keys true))
                                 :settings {
                                            :cacheVersion (aget js/window "_pt" "client_version")
                                            :enableSearch true
                                            :disableBookmarks true
                                            :maxNumberOfFavorites (aget js/window "_pt" "max_number_of_favorites")
                                            :enableSettings false
                                            :enableFolders  (folders/is-folders-enabled module)
                                            :enableAddFilters false
                                            :resizable false}}]]))))

(def default-test-cols
  [{:type          :test_type
    :field         :test_type
    :default-width 80
    :default-show? true
    :autofilter?   true
    :multiple?     true
    :sortable?     true
    :header        "Type"}
   {:type          :display_id
    :field         :display_id
    :autofilter?   true
    :default-width 80
    :header        "Id"
    :sortable?     true}
   {:type          :custom-field-url
    :field         :name
    ;; Fixed width (fill all remaining space)
    :default-width 250
    :resizable?    true
    :default-show? true
    :autofilter?   true
    :sortable?     true
    :header        "Name"}
   {:type          :linked-entities
    :default-width 200
    :default-show? true
    :autofilter?   false
    :sortable?     false
    :header        "Linked Test Sets"
    :field         :linked_testsets
    :new-tab?      true}])

(def extra-test-cols
  [{:type          :number
    :field         :steps_count
    :default-width 80
    :resizable?    true
    :default-show? false
    :autofilter?   true
    :text-align    "center"
    :multiple?     true
    :sortable?     true
    :header        "Steps count"}])

(re-frame/reg-sub
  ::columns
  (fn [db _]
    (let [fields (:fields db)
          entity-fields (get-in db [:entity-fields :test])
          keys (keys (apply (partial dissoc entity-fields) test-fields-to-exclude))
          filtered-keys (filter (partial grid.subs/filter-out-memo? fields) keys)]
      (concat
        default-test-cols
        extra-test-cols
        (mapv
          (fn [f]
            (assoc (grid.subs/field->column nil (get fields f))
              :default-show? false))
          filtered-keys)))))

(re-frame/reg-sub
  ::current-project
  (fn [db _]
    (:current-project db)))

(re-frame/reg-sub
  ::full-data?
  (fn [db _]
    (get-in db [:entity :testset :add-instances-state :full-data?])))

(re-frame/reg-sub
  ::filter-cols
  (fn [db _]
    (get-in db [:entity :testset :add-instances-state :filter-cols])))

(re-frame/reg-sub
  ::selection
  (fn [db _]
    (get-in db [:entity :testset :add-instances-state :selection])))

(re-frame/reg-sub
  ::current-suite
  (fn [db _]
    (get-in db [:entity :testset :current])))

(defn- highlight-instance-row
  [selected-tests added-tests _ {:keys [id display_id] :as row}]
  {:class (dom/classes-pairs
            :table-selected-row (contains? selected-tests id)
            :table-added-row (contains? added-tests display_id))})

(defn add-tests-component [_ _ _]
  (let [local-grid-state (reagent/atom {})] ;; Create a local grid state that's separate from the main grid
    (fn [_]
      (let [instances @(re-frame/subscribe [::grid.subs/data [:testset :instances-state]])
            selected-tests          (set @(re-frame/subscribe [::testset.subs/selected-tests]))
            test-display-ids        (map :test/display_id instances)
            added-tests             (set test-display-ids)
            adding-instances?       @(re-frame/subscribe [::subs/progress? ::testset2/add-instances])
            current-page            @(re-frame/subscribe [::testset.subs/add-instances-current-page])

            tests-data-sub          @(re-frame/subscribe [::testset.subs/tests])
            full-data?              @(re-frame/subscribe [::full-data?])
            filter-cols              @(re-frame/subscribe [::filter-cols])

            table-id                (str (:id @(re-frame/subscribe [::current-project])) "-add-instances-dialog")
            add-instance-table-id   (str table-id "-filters") ;; Use a different key for add instance filters
            dialog-state            (re-frame/subscribe [::testset.subs/add-instances-grid-state])
            data                    (mapv transform-test-name-for-url tests-data-sub)]
        [:div.h-100
         [:div.filter-tree-and-grid-container
          [panel-group  {:auto-save-id "index-content-panel"}
           [panel-resizeable {:default-size (get-in panel-config [:filters :default-size])
                              :min-size (get-in panel-config [:filters :min-size])}
            [filters-view {:current-item     @(re-frame/subscribe [::testset.subs/current-filter-selected])
                           :fetching?        @(re-frame/subscribe [::subs/progress? ::testset2/fetch-filters])
                           :module           "Test"
                           :state-key        :add-instances-state
                           :grid-state       local-grid-state}]]
           [panel-resize-handle]
           [panel-resizeable {:default-size (get-in panel-config [:grid :default-size])
                              :min-size     (get-in panel-config [:grid :min-size])}
            [:div.add-instances-data-grid
             [grid2/grid
              {:allows-added-rows?    true
               :loading?              @(re-frame/subscribe [::subs/progress? ::testset2/fetch-tests])
               :fields                @(re-frame/subscribe [::subs/fields])
               :columns               @(re-frame/subscribe [::columns])
               :data                  data
               ;; Highlight for existing/selected tests
               :row-props-fn          (reagent/partial highlight-instance-row selected-tests added-tests)
               :total-count           @(re-frame/subscribe [::testset.subs/add-instances-total-count])
               :show-edit-columns?    true
               :current-page          (when-not full-data?
                                        (or current-page 1))
               :on-query-changed      (when-not full-data?
                                        (partial-dispatch [::testset2/fetch-tests dialog-state]))
               ;; Dynamic server-side/client-side pagination support
               :selected?             (partial-subscribe [::grid.subs/selected? [:testset :add-instances-state]])
               :all-selected?         (partial-subscribe [::grid.subs/all-selected? [:testset :add-instances-state]])
               :toggle-selection      (partial-dispatch [::grid.events/toggle-selection [:testset :add-instances-state]])
               :toggle-selection-page (partial-dispatch [::grid.events/toggle-selection-page [:testset :add-instances-state]])
               :filter-cols           filter-cols
               :options               {:selectable? true}
               :full-data?            @(re-frame/subscribe [::full-data?])
               :resizable?            true
               :grid-state            local-grid-state
               :selected-tests        (set @(re-frame/subscribe [::testset.subs/selected-tests]))
               :added-tests           (set (map :test/display_id @(re-frame/subscribe [::grid.subs/data [:testset :instances-state]])))
               :adding-instances?     adding-instances?
               :clear-selection       (partial-dispatch [::testset2/clear-selection])
               :close-instances-dialog       (partial-dispatch [::testset2/hide-add-instances-modal])
               :selection             @(re-frame/subscribe [::selection])
               :get-field-props       #(re-frame/subscribe [::forms/field-props :test %])
               :columns-settings-save (reagent/partial grid-storage/save-column-settings table-id)
               :columns-settings-load (reagent/partial grid-storage/load-column-settings table-id)
               :columns-widths-save   (reagent/partial grid-storage/save-column-sizes table-id)
               :columns-widths-load   (reagent/partial grid-storage/load-column-sizes table-id)
               :per-page-save         (reagent/partial grid-storage/save-per-page table-id)
               :per-page-load         (reagent/partial grid-storage/load-per-page table-id)
               :autofilters-save      (reagent/partial grid-session-storage/save-autofilters add-instance-table-id)
               :autofilters-load      (reagent/partial grid-session-storage/load-autofilters add-instance-table-id)
               :added-row-tooltip     (get-translation "testset.instances.added-row.tooltip"
                                                    "This Test is already linked to the Test Set")}]]]]]]))))
